import { ReactElement } from "react";
import { ContactGlobalSearchResultItem, GlobalSearchScopeIdentifier } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { ContactListItem } from "../../../Items/ContactListItem";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { ContactSource } from "client/Api/Email/contacts";
import { generateTrackingId } from "client/Misc/utils";
import { useContactNavigationHandler } from "../../../Navigation/useContactNavigationHandler";

export type ContactItemViewProps = {
	item: ContactGlobalSearchResultItem;
	itemIndex: number;
	itemScope: GlobalSearchScopeIdentifier;
	searchTerm: string;
	onOpenContactDetails: (id: string, source: ContactSource) => void;
	tabIndex: number;
};

export const ContactItemView = (props: ContactItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		itemScope,
		searchTerm,
		onOpenContactDetails,
		tabIndex
	} = props;

	const {
		contact,
		contactSource,
		hitHighlights
	} = item;

	const {
		jobTitle,
		department,
		company,
		id,
		photoUrl,
		firstName,
		middleName,
		lastName,
		displayName,
		emailAddress,
		phoneNumber
	} = contact;

	const openHandler: () => void = useContactNavigationHandler({
		id,
		contactSource,
		onOpenContactDetails,
		searchResult: item,
		itemScope: itemScope
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("contact-item", `|${contactSource}/${id}`)}
			onClick={openHandler}
		>
			<ContactListItem
				contactSource={contactSource}
				id={id}
				firstName={firstName}
				middleName={middleName}
				lastName={lastName}
				displayName={displayName}
				jobTitle={jobTitle}
				department={department}
				company={company}
				emailAddress={emailAddress}
				phoneNumber={phoneNumber}
				photoUrl={photoUrl}
				highlightConfiguration={{
					searchTerm: searchTerm,
					hitHighlights: hitHighlights
				}}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};

ContactItemView.displayName = "ContactGlobalSearchItemView";
